import moment from 'moment';

interface HistoryPoint {
  referenceDate: Date | string;
  value: number | null;
}

// A constant offset is an estimate: preserve historical changes and missing quotes.
export function buildWalletHistory(
  history: readonly HistoryPoint[],
  currentTotal?: number
): HistoryPoint[] {
  const sorted = history
    .filter(item => moment(item.referenceDate).isValid())
    .slice()
    .sort((a, b) => moment(a.referenceDate).valueOf() - moment(b.referenceDate).valueOf());
  const latestKnown = [...sorted].reverse().find(item =>
    item.value !== null && Number.isFinite(item.value)
  );
  if (!latestKnown || currentTotal === undefined || !Number.isFinite(currentTotal)) {
    return sorted;
  }
  const offset = Math.max(0, currentTotal - latestKnown.value!);
  if (!offset) return sorted;
  return sorted.map(item => ({
    ...item,
    value: item.value === null ? null : item.value + offset,
  }));
}
